export var KIND_LOGO = 'logo';
export var KIND_BUNDLE_STATS = 'bundlestats';
export var KIND_LOGOTYPE = 'logotype';
export var KIND_GITHUB = 'github';
export var KIND_WEBPACK = 'webpack';
export var KIND_DEFAULT = KIND_LOGO;
export var KINDS = [KIND_LOGO, KIND_BUNDLE_STATS, KIND_LOGOTYPE, KIND_GITHUB, KIND_WEBPACK];